/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Terminkennzeichen } from '../models';
/**
 * TerminkennzeichenService - axios parameter creator
 * @export
 */
export const TerminkennzeichenServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Terminkennzeichen
         * @summary Terminkennzeichen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminkennzeichen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/terminkennzeichen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert ein Terminkennzeichen
         * @summary Terminkennzeichen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminkennzeichenById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTerminkennzeichenById', 'id', id)
            const localVarPath = `/api/terminkennzeichen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminkennzeichenService - functional programming interface
 * @export
 */
export const TerminkennzeichenServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminkennzeichenServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Terminkennzeichen
         * @summary Terminkennzeichen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminkennzeichen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Terminkennzeichen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminkennzeichen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert ein Terminkennzeichen
         * @summary Terminkennzeichen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminkennzeichenById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Terminkennzeichen>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminkennzeichenById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerminkennzeichenService - factory interface
 * @export
 */
export const TerminkennzeichenServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminkennzeichenServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Terminkennzeichen
         * @summary Terminkennzeichen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminkennzeichen(options?: any): AxiosPromise<Array<Terminkennzeichen>> {
            return localVarFp.getTerminkennzeichen(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert ein Terminkennzeichen
         * @summary Terminkennzeichen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminkennzeichenById(id: number, options?: any): AxiosPromise<Terminkennzeichen> {
            return localVarFp.getTerminkennzeichenById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminkennzeichenService - interface
 * @export
 * @interface TerminkennzeichenService
 */
export interface TerminkennzeichenServiceInterface {
    /**
     * Liefert eine Liste von Terminkennzeichen
     * @summary Terminkennzeichen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminkennzeichenServiceInterface
     */
    getTerminkennzeichen(options?: any): AxiosPromise<Array<Terminkennzeichen>>;

    /**
     * Liefert ein Terminkennzeichen
     * @summary Terminkennzeichen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminkennzeichenServiceInterface
     */
    getTerminkennzeichenById(id: number, options?: any): AxiosPromise<Terminkennzeichen>;

}

/**
 * TerminkennzeichenService - object-oriented interface
 * @export
 * @class TerminkennzeichenService
 * @extends {BaseAPI}
 */
export class TerminkennzeichenService extends BaseAPI implements TerminkennzeichenServiceInterface {
    /**
     * Liefert eine Liste von Terminkennzeichen
     * @summary Terminkennzeichen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminkennzeichenService
     */
    public getTerminkennzeichen(options?: any) {
        return TerminkennzeichenServiceFp(this.configuration).getTerminkennzeichen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert ein Terminkennzeichen
     * @summary Terminkennzeichen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminkennzeichenService
     */
    public getTerminkennzeichenById(id: number, options?: any) {
        return TerminkennzeichenServiceFp(this.configuration).getTerminkennzeichenById(id, options).then((request) => request(this.axios, this.basePath));
    }
}
